import { handleFormError } from 'assets/js/misc';

angular.module('logbook')
.directive('userListEditor', ['$timeout', "$http", "$location", "$window", "$q",
function($timeout, $http, $location, $window, $q) {
  return {
    restrict: 'E',

    scope: {
       updateUri: '=',
       updateObj: '=',
       allowedUsersField: '@',
       allowAllField: '@',
       editing: '=',
       selectedLog: '=',
       onSave: '=',
       overrideUserList: '=',
       disableAllowAll: '@?'
    },

	template: require('./user-list-editor.html'),

    link: function(scope, elem, attrs) {
       scope.usersToAdd = [];
       scope.usersToRemove = [];
       scope.allowedUsers = {};
       scope.allowAllUsers = !scope.updateObj[scope.allowAllField]
          ? "false"
          : scope.updateObj[scope.allowAllField].toString();

       var deferred = $q.defer();
       var userListPromise = deferred.promise;
       if( scope.overrideUserList )
          deferred.resolve(scope.overrideUserList);
       else
          $http.get('/api/logUsers?size=1000',
             { params: 
                {
                   "log" : scope.selectedLog.id
                }
             }
          ).then(function(result) {
             deferred.resolve(result.data._embedded.logUsers);
          });
             
       userListPromise.then(function(users) {
             scope.users = users;
             scope.allowedUsers = {};
             scope.updateAccessForm.$show();
             
             scope.updateObj[scope.allowedUsersField].forEach(function(user) {
                scope.allowedUsers[user._links.self.href] = true;
             });

          });
       scope.toggleUserAllowed = function(user) {
           var allowed = scope.allowedUsers[user._links.self.href];
           var arrToAdd = allowed ? scope.usersToAdd : scope.usersToRemove;
           var arrToRemove = allowed ? scope.usersToRemove : scope.usersToAdd;
           
           var addIdx = arrToAdd.indexOf(user.id);
           var remIdx = arrToRemove.indexOf(user.id);
           
           if( addIdx < 0 && remIdx < 0 )
              arrToAdd.push(user.id);
              
           if( remIdx >= 0 && addIdx < 0)
              arrToRemove.splice( arrToRemove.indexOf(user.id), 1 );
       };
       
       scope.updateAllowedUsers = function() {
          delete scope.saveError;
          var d = $q.defer();
          var update = {
            "addToCollections": {},
            "removeFromCollections": {}
          };
          
          update["addToCollections"][scope.allowedUsersField] = scope.usersToAdd;
          update["removeFromCollections"][scope.allowedUsersField] = scope.usersToRemove;
          if( scope.allowAllField )
             update[scope.allowAllField] = scope.allowAllUsers=='true';
          $http.patch(scope.updateUri, update,
                { 'noErrorPopup' : true,
                  'rawError': true
                }
             ).then(function() {
                scope.editing = false;
                scope.fireSavedEvent(); 
                d.resolve();
             }, function(errors) {
                if( Array.isArray(errors) )
                   handleFormError(d, scope.updateAccessForm, errors);
                else if(typeof(errors) == 'string')
                   scope.saveError = errors;
             });
          return d.promise;
       };
       
       scope.fireSavedEvent = function()
       {
          scope.onSave && scope.onSave(scope.updateObj);
       }
       

    }
  }
}]);
